
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/hipaa-notice-of-privacy-practices",
      function () {
        return require("private-next-pages/legal/hipaa-notice-of-privacy-practices.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/hipaa-notice-of-privacy-practices"])
      });
    }
  